
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/mission/transparency",
      function () {
        return require("private-next-pages/about/mission/transparency.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/mission/transparency"])
      });
    }
  